import { render, staticRenderFns } from "./EndingModule.vue?vue&type=template&id=60283452&scoped=true&"
import script from "./EndingModule.vue?vue&type=script&lang=js&"
export * from "./EndingModule.vue?vue&type=script&lang=js&"
import style0 from "./EndingModule.vue?vue&type=style&index=0&id=60283452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60283452",
  null
  
)

export default component.exports